// extracted by mini-css-extract-plugin
module.exports = {"anchor":"styles__anchor___39LY0","span":"styles__span___v7tza","active":"styles__active___1JKhQ"};